import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { Citation } from '../api/schemas';

type Props = { title: string; meta?: string; citation: Citation | undefined; children: ReactNode };

/** A titled box for figures read straight from OCBC's tables, with the report they come from. */
export function PanelFrame({ title, meta, citation, children }: Props) {
  return (
    <Box
      component="section"
      aria-label={title}
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1.5,
        bgcolor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        sx={{ alignItems: 'baseline', gap: 1, px: 1.75, pt: 1.25, pb: 1, flexWrap: 'wrap' }}
      >
        <Typography variant="subtitle2">{title}</Typography>
        {meta ? (
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {meta}
          </Typography>
        ) : null}
        {citation ? (
          <Link
            component={RouterLink}
            to={`/documents/${citation.documentId}?page=${citation.page}`}
            variant="caption"
            sx={{ ml: 'auto', color: 'text.secondary' }}
          >
            [{citation.n}] {citation.title} · p.{citation.page}
          </Link>
        ) : null}
      </Stack>
      {children}
    </Box>
  );
}
